// import jqXHR = JQuery.jqXHR;
import { ApiRoute } from "PFCore/utilities/routes";
import { Collection, PermissionsGroup } from "PFTypes";
import { QueryParams } from "PFTypes/query_params";

export const fetchPermissionsGroups = ({
  page = 1,
  perPage = 0
}: QueryParams): Promise<Collection<PermissionsGroup[]>> => {
  const searchParams = new URLSearchParams({
    page: page.toString(),
    per_page: perPage.toString()
  });

  // @ts-ignore
  return $.ajax({
    url: ApiRoute(`/api/admin/permissions_groups?${searchParams.toString()}`),
    api_version: 2
  });
};
